export default __webpack_public_path__ + "static/media/Front-Apartment-Mr-El-Sayid-5.7a0c897d.jpg";